import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { shipmentTableCustomStyles } from "../../../utils/TableCustomStyles";

function PlannedImport() {
  const filterform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [salesUser, setSalesUser] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const user_role = sessionStorage['userrole']  
  const [showFilterForm, setShowFilterForm] = useState(false);
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [totalData, setTotalData] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);


  const getLoggenInUser = async () => {
      try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+user_id);
          if (response) {
              setLoggedInUser(response.data)
          }
      } catch (err) {
          toast.error("Error in fetching user data! Try again.");
      }
  }

  
  const getShipment = async (page = 1, size = 10) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/shipment/getimportshipment/?page='+page);
        setTimeout(() => {
          if (response) {
              const export_shipment = response.data.results
              setData(export_shipment)
              setCurrentPage(page);
              setTotalData(response.data?.count)
              setDataPending(false)
          }
        }, 500);
        
    } catch (err) {
        toast.error("Error in fetching shipment data! Try again.");
    }
  }

  const filterData = async (e, page = 1, size = 10) => {
    e.preventDefault();
    const booking_number = filterform.current.booking_number.value
    const cargo_type = filterform.current.cargo_type.value
    const booking_status = filterform.current.booking_status.value
    const payment = filterform.current.payment_type.value
    const sales_person = filterform.current.sales_person.value
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/shipment/getimportshipment/?page='+page+
                                        "&booking_number="+booking_number+"&cargo_type="+cargo_type+"&booking_status="+booking_status+
                                        "&payment="+payment+"&sales_person="+sales_person);

        if (response) {
            const export_shipment = response.data.results
            setData(export_shipment)
            setCurrentPage(page);
            setTotalData(response.data?.count)
            setDataPending(false)
        }
    } catch (err) {
        toast.error("Error in fetching shipment data! Try again.");
    }

  }

  const getSalesUser = async () => {
      try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/getsalesuser');
          if (response) {
              setSalesUser(response.data)
          }
      } catch (err) {
          toast.error("Error in fetching sales user data! Try again.");
      }
  }

  const getCurrentUserRolePermission = async (roles) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
        
        const role_permissions_array = []
        for(let i=0; i<response.data.length; i++){
            for(let j=0; j<response?.data[i]?.permissions_array.length; j++){
                if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                    role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                }
            }
        }

        if(role_permissions_array){
            setCurrentUserRolePermissionData(role_permissions_array)
        }
          
    } catch (err) {
        toast.error("Error in fetching user role data! Try again.");
    }
  }


  useEffect(() => {
    getShipment(currentPage)
    getLoggenInUser()
    getSalesUser()
  }, []);

  const handlePageChange = (page) => {
    getShipment(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    getShipment(page, newPerPage);
  };

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const get_user = (userjson) => {
    if(!userjson==""){
      const user_data = JSON.parse(userjson)
      return user_data?.name
    }
    else{
      return "None"
    }
    
  }

  const columns = [
    {
      name: 'Booking No.',
      width: '220px',
      selector: row => row.reference_number,
      sortable: true,
    },
    {
      name: 'Route',
      width: '270px',
      selector: row => 
        <>
          <span><b>POA:</b> {row.poa_data?.name}</span><br></br>
          <span><b>POL:</b> {row.pol_data?.name} - {row.pol_terminal_data?.name}</span><br></br>
          <span><b>POD:</b> {row.pod_data?.name}</span><br></br>
          <span><b>FD:</b> {row.fd_data?.name}</span><br></br>
          <span>
            <b>Transhipment: </b> 
            {row.transhipment_sequence && Object.values(row.transhipment_sequence).length > 0 ? (
              Object.values(row.transhipment_sequence).map(transhipment => (
                <>
                  <br />
                  <span key={transhipment.id}>
                    {transhipment.index} - {transhipment.name}
                  </span>
                </>
              ))
            ) : (
              <span>None</span>
            )}
          </span>
          <hr></hr>
          <span>
            <b>Vessel Schedule: </b> 
            {row?.first_vessel_schedule_data?.vessel_data?.name ?
              <span>{row?.first_vessel_schedule_data?.vessel_data?.name} {row?.first_vessel_schedule_data?.voyage} ({row?.first_vessel_schedule_data?.eta_date})</span>
              :
              "None"
            }
          </span><br></br>
        </>,
      sortable: true,
    },
    {
      name: 'Cargo',
      width: '220px',
      selector: row => 
        <>
          <span className={`${row.booking_line_item?.[0]?.cargo_type == "HAZARDOUS"?"fw-bold bg-danger text-white px-2 rounded":""}`}>
            {row.booking_line_item?.[0]?.cargo_type.replaceAll("_"," ")}
          </span><br></br>
          <span>{row.booking_line_item?.[0]?.container_quantity} x {row.booking_line_item?.[0]?.container_type}</span><br></br>
          <span>{row.booking_line_item?.[0]?.commodity}</span><br></br>
          <span>Weight: {Number(row.booking_line_item?.[0]?.weight) + Number(row.booking_line_item?.[0]?.tare_weight)} MT</span>
        </>
    },
    {
      name: 'Stakeholders',
      width: '320px',
      selector: row => 
        <>
          <span><b>Principal:</b> {row.principal_data?.name}</span><br></br>
          <span><b>Booking Agent:</b> {row.booking_agent_data?.name}</span><br></br>
          <span><b>Delivery AGent:</b> {row.delivery_agent_data?.name}</span><br></br>
          <span><b>Shipper:</b> {row.shipper}</span><br></br>
          <span><b>Booking Party:</b> {row.booking_party_data?.name}</span><br></br>
          <span><b>Customer:</b> {row.customer_data?.name}</span><br></br>
          <span><b>Slot Operator:</b> {row.slot_operator_data?.name}</span><br></br>
          <span><b>Slot Payment Agent:</b> {row.slot_payment_agent_data?.name}</span><br></br>
          <span><b>Sales Person:</b> {row.sales_person_data?.name}</span><br></br>
          <span><b>Rate Approved By:</b> {row.rate_approved_by_data?.name}</span><br></br>
          <span><b>Space Confirmed By:</b> {row.space_confirmed_by_data?.name}</span><br></br>
          <span><b>In Transit To:</b> {row.in_transit_to_data?.name}</span>
        </>,
      sortable: true,
    },
    {
      name: 'BL and Schedule',
      width: '160px',
      selector: row => 
        <>
          <span><b>BL Type:</b> {row.bl_type}</span><br></br>
          <span><b>BL Sub Type:</b> {row.bl_sub_type}</span><br></br>
        </>,
      sortable: true,
    },
    // {
    //   name: 'Free Days',
    //   width: '110px',
    //   selector: row => 
    //     <>
    //       <span><b>POA :</b> {row.poa_free_days}</span><br></br>
    //       <span><b>POD :</b> {row.pod_free_days}</span>
    //     </>,
    //   sortable: true,
    // },
    {
      name: 'Other Details',
      width: '160px',
      selector: row => 
        <>
          <span><b>IEC Code:</b> {row.iec_code}</span><br></br>
          <span><b>Payment:</b> <span className={`${row.payment == "COLLECT"?"blink fw-bold bg-inox-green text-white px-2 rounded":""}`}>{row.payment}</span></span>
        </>,
      sortable: true,
    },
    {
      name: 'Total Amount',
      width: '150px',
      selector: row => 
        <>
          <span><b>Import Local:</b> {row.total_import_local_amount}</span><br></br>
          <span><b>Export Local:</b> {row.total_export_local_amount}</span>
        </>,
      sortable: true,
    },
    {
      name: 'Status',
      center: true,
      width: '200px',
      selector: row => 
        <div style={{ borderRadius: 5, 
                      backgroundColor: row.status === "DRAFT" ? "#B2EBF2" : 
                                      row.status === "WAITING_APPROVAL" ? "#FFF3CD" :
                                      row.status === "APPROVED" ? "#C3E6CB" :
                                      row.status === "NOT_APPROVED" ? "#FFE5B4" :
                                      row.status === "REJECTED" ? "#F5C6CB" :
                                      row.status === "CANCELLED" ? "#D6D8DB" : "#000" }}>
          <p className="px-3 my-2 fw-bold">{row.status?.replaceAll("_"," ")}</p>
        </div>,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      width: '100px',
      selector: row => <div>
        {/* {
          currentUserRolePermissionData?.includes("draftbooking:draftshipment:update")?
          <a href={"/draftbooking/draftbookingrequest/"+row.id}>
            <Button className="btn btn-sm btn-inox-green border-0" title="View">
              <i className="fa fa-eye"></i>
            </Button>
          </a>
          :
          ""
        } */}
        
        <a href={"/draftbooking/draftbookingrequest/"+row.id}>
          <Button className="btn btn-sm btn-inox-green border-0" title="View">
            <i className="fa fa-eye"></i>
          </Button>
        </a>
      </div>,
    }
  ];

  const [visibleCols, setVisibleCols] = useState(columns);

  const toggleColumn = (colName) => {
    let updatedCols;

    if (visibleCols.some(c => c.name === colName)) {
      updatedCols = visibleCols.filter(c => c.name !== colName);
    } else {
      updatedCols = [...visibleCols, columns.find(c => c.name === colName)];
    }

    const sortedCols = columns.filter(col =>
      updatedCols.some(vc => vc.name === col.name)
    );

    setVisibleCols(sortedCols);
  };

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="Shipment" activeSubMenu="Imports" activeSubMenuLevel1="PlannedImports" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-2 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Planned Imports</span>
            </div>

            <div className="col-10 py-1">
              <div class="dropdown">
                <button type="button" style={{ paddingTop: 7, paddingBottom: 8, float: 'right', marginRight: 20, width: 35 }} title="Language" class="btn btn-inox-green border-0 text-white" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-flex align-items-center">
                        <span className="fa fa-bars"></span>
                    </span>
                </button>

                <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                  {columns.map(col => (
                  <span class="dropdown-item pointer pointer">
                      <span>
                        <input type="checkbox" 
                              checked={visibleCols.some(c => c.name === col.name)}
                              onChange={() => toggleColumn(col.name)}/> {col.name}
                      </span>
                  </span>
                  ))}
                </div>
              </div>
              {!showFilterForm?
                <Button className="btn btn-sm btn-inox-green border-0 px-2 float-right" title="Filter Data" style={{ paddingTop: 5, marginRight: 5 }} onClick={() => setShowFilterForm(!showFilterForm)}>
                  <i className="fa fa-filter fa-lg text-right"></i>
                </Button>
              :
                <form ref={filterform}>
                  <div className="row justify-content-end" >
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <input type="text" readonly className="form-control form-control-sm" name="booking_number" placeholder="Booking Number"/>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="cargo_type">
                        <option value="">Select Type</option>
                        <option value="HAZARDOUS">HAZARDOUS</option>
                        <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                        <option value="EMPTY">EMPTY</option>
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="booking_status">
                        <option value="">Select Status</option>
                        <option value="WAITING_APPROVAL">WAITING APPROVAL</option>
                        <option value="APPROVED">APPROVED</option>
                        <option value="NOT_APPROVED">NOT APPROVED</option>
                        <option value="REJECTED">REJECTED</option>
                        <option value="CANCELLED">CANCELLED</option>
                        <option value="SOB">SOB</option>
                        <option value="CLOSED">CLOSED</option>
                        <option value="DRAFT">DRAFT</option>
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="payment_type">
                        <option value="">Select Payment</option>
                        <option value="COLLECT">Collect</option>
                        <option value="PREPAID">Prepaid</option>
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="sales_person">
                        <option value="">Select Sales Person</option>
                        {salesUser && salesUser.map(user => 
                          <option value={user.id}>{user.name}</option>
                        )}
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <Button className="btn btn-sm btn-secondary mx-1 float-right mr-1 pb-1" style={{ width: 35 }} onClick={() => [setShowFilterForm(!showFilterForm), getShipment(currentPage)]}>
                        <i className="fa fa-times"></i>
                      </Button>

                      <Button className="btn btn-sm btn-inox-green border-0 float-right" style={{ paddingBottom: 6, width: 100 }} onClick={(e) => filterData(e,1,10)}>Search</Button>
                    </div>
                  </div>
                </form>
              }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30 }}>
          <DataTable
            columns={visibleCols}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            highlightOnHover
            // fixedHeader
            customStyles={shipmentTableCustomStyles}
            dense
            pagination
            paginationServer
            paginationTotalRows={totalData}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}

export default PlannedImport;
